module.exports = __webpack_public_path__ + "assets/img/1605_01.jpg?8a695ea2d5965b7d4861b1fd81e0c086";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1605_01.jpg
// module id = 1104
// module chunks = 0